import { render, staticRenderFns } from "./IBarcode.vue?vue&type=template&id=fd87b6ae&"
import script from "./IBarcode.vue?vue&type=script&lang=ts&"
export * from "./IBarcode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports